import { useState } from 'react';
import { HeartPulse, Landmark, Calculator, MessageSquare } from 'lucide-react';

// Iter 485 : popup bloquante de motif quand un pointage est hors planning
// (entree en retard au-dela de la tolerance / sortie anticipee).
const REASONS = {
  late_entry: [
    { code: 'medical_emergency', label: 'Urgence médicale', Icon: HeartPulse, color: '#DC2626' },
    { code: 'bank_deposit', label: 'Dépôt en banque', Icon: Landmark, color: '#003480' },
    { code: 'other', label: 'Autre (précisez)', Icon: MessageSquare, color: '#6B7280' },
  ],
  early_exit: [
    { code: 'bank_deposit', label: 'Dépôt en banque', Icon: Landmark, color: '#003480' },
    { code: 'cash_closing', label: 'Fermeture de caisse', Icon: Calculator, color: '#059669' },
    { code: 'other', label: 'Autre (précisez)', Icon: MessageSquare, color: '#6B7280' },
  ],
};

export const OffScheduleReasonModal = ({ open, offSchedule, onSubmit, submitting }) => {
  const [otherNote, setOtherNote] = useState('');
  const [showOther, setShowOther] = useState(false);
  if (!open || !offSchedule) return null;
  const isEntry = offSchedule.type === 'late_entry';
  const reasons = REASONS[offSchedule.type] || REASONS.early_exit;
  const delta = Math.abs(offSchedule.delta_minutes || 0);

  return (
    <div className="fixed inset-0 z-[80] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="off-schedule-modal">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm p-5 space-y-4">
        <div className="text-center">
          <p className="text-3xl">⏱️</p>
          <h3 className="font-heading text-lg text-[#003480] mt-1">
            {isEntry ? 'Entrée en retard' : 'Sortie anticipée'}
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            {isEntry
              ? `Vous pointez ${delta} min après votre horaire prévu (${offSchedule.scheduled_time}).`
              : `Vous pointez ${delta} min avant votre horaire prévu (${offSchedule.scheduled_time}).`}
            <br />Merci d&apos;indiquer le motif :
          </p>
        </div>
        {!showOther ? (
          <div className="space-y-2">
            {reasons.map(({ code, label, Icon, color }) => (
              <button
                key={code}
                disabled={submitting}
                onClick={() => (code === 'other' ? setShowOther(true) : onSubmit(code, null))}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-2xl border-2 border-gray-100 hover:border-[#003480]/40 hover:bg-blue-50/50 transition-colors text-left disabled:opacity-50"
                data-testid={`off-reason-${code}`}
              >
                <Icon className="w-5 h-5 shrink-0" style={{ color }} />
                <span className="font-semibold text-sm text-gray-800">{label}</span>
              </button>
            ))}
          </div>
        ) : (
          <div className="space-y-2">
            <textarea
              value={otherNote}
              onChange={(e) => setOtherNote(e.target.value)}
              placeholder="Précisez le motif..."
              rows={3}
              className="w-full border-2 border-gray-200 rounded-2xl p-3 text-sm focus:border-[#003480] outline-none"
              data-testid="off-reason-other-input"
            />
            <div className="flex gap-2">
              <button onClick={() => setShowOther(false)} disabled={submitting}
                className="flex-1 py-2.5 rounded-2xl bg-gray-100 text-sm font-semibold text-gray-600" data-testid="off-reason-other-back">
                Retour
              </button>
              <button onClick={() => onSubmit('other', otherNote.trim())} disabled={submitting || !otherNote.trim()}
                className="flex-1 py-2.5 rounded-2xl bg-[#003480] text-white text-sm font-semibold disabled:opacity-40" data-testid="off-reason-other-submit">
                {submitting ? 'Envoi...' : 'Valider'}
              </button>
            </div>
          </div>
        )}
        <p className="text-[10px] text-gray-400 text-center">
          Ce motif sera visible par votre responsable dans la validation des pointages.
        </p>
      </div>
    </div>
  );
};

export default OffScheduleReasonModal;
